import React , { useEffect, useState }  from 'react'
import PropTypes from 'prop-types'
import CustomForm from '../../../../components/form/form'
import { Main } from '../../../../constant'
import { CustomBtn } from '../../../../components/button/button'
import { Box, Grid } from '@mui/material'
import CustomTable from '../../../../components/table/SimpleTable'
import PageContainer from '../../../../components/Container/pageContainer'
import { useDispatch, useSelector } from 'react-redux'
import axios from 'axios'
import { FullDate } from '../../../../components/Date/FullDate'
import { PostRequest } from '../../../../redux/actions/PostRequest'
import CustomTableFinance from '../components/expenseTable'
import { ShowLoader } from '../../../../redux/actions/loader'

const Expense = (props) => {
    const [data , setData ] = useState(Main().Expense)
    const [getfilterdata , setGetfilterdata ] = useState(data.inputs.filter((item) => item.feildtype !== 'label'));
    const dispatch = useDispatch();
    const url = useSelector((state) => state.Api);
    const userToken = JSON.parse(sessionStorage.getItem('User_Data'))?.token || undefined;
    const [initialInputValues , setInitialInputValues] = useState(Object.fromEntries(
        getfilterdata
            .map((item) => [item.name, ''])
    ));
    const [ serverData , setServerData ] = useState()
        const [formKey, setFormKey] = useState(0);
    const [inputValues, setInputValues] = useState({...initialInputValues });
    function handleInputChange(e) {
        setInputValues((prevValues) => ({
            ...prevValues,
            [e.target.name]: e.target.value,
        }));
    }
    
    const submitForm = async(e) =>{
        dispatch(ShowLoader('1'))
        e.preventDefault();
        const getCategories = sessionStorage.getItem('ExpenseCat')
        const getCateName = JSON.parse(getCategories).find(item => item.Srn === inputValues.Category)
        console.log(getCateName.categoryName)
        inputValues.CategoryName = getCateName.categoryName
        // console.log(inputValues)
        // return false
        await dispatch(PostRequest(url.expense , userToken , inputValues))
        setInputValues({...initialInputValues});  // Reset to initial values
        console.log(inputValues)
        refreshForm()
        fetchData()
        dispatch(ShowLoader('0'))
    }


      
    const fetchData = async (param1 , param2) => {
    dispatch(ShowLoader('1'))
    const FromDate = new Date(param1);
    const newdate = `${FromDate.getFullYear()}-${FromDate.getMonth() + 1}-${FromDate.getDate()}`;
    //console.log(newdate)
    

    // const payload = {...inputValues , ...Box(param1 ? {[param2]:newdate} : {})}
    const payload = { 
        ...inputValues,
        ...(param1 ? { [param2]: newdate } : {})
    };
    
    //console.log(payload)
        try {
            const response = await axios.post(url.veiwexpense, payload, {
                headers: {
                    'Content-Type': 'application/json',
                    'Authorization': `Bearer ${userToken}`,
                },
            });

            if (response.status === 200) {
            // setServerData(response.data.result);
                    dispatch(ShowLoader('0'))
            if(response.data.result != []){
                setServerData((prevValues) => ({
                    ...prevValues,
                    veiwDonation: response.data.result,
                }));
            }
            }
        } catch (error) {
            //console.error(error);
        }
    };



    const ChangeDate = (e , name) =>{
        //console.log(e , name)
        const converterToDate = new Date(e)
        setInputValues((prevValues) => ({
            ...prevValues,
            [name]:  `${converterToDate.getFullYear()}-${converterToDate.getMonth() + 1}-${converterToDate.getDate()}`
    }));
    fetchData(e,name)
    }

    const ChangeOnSelectView = (getparam) => {
        setInputValues((oldData)=> ({
            ...oldData,
            [getparam[1]]:getparam[0]
        })
        )
        // console.log(inputValues)
    }
    
    const ChangeOnSelect = (getparam) => {
        // console.log()
        setInputValues((oldData)=> ({
            ...oldData,
            [getparam[1]]:getparam[0]
        })
        )
        console.log(inputValues)
    }
    const refreshForm = () => {
        setFormKey(prevKey => prevKey + 1);
    }

    const deleteRecord = async(getId) =>{
        console.log(getId)
        dispatch(ShowLoader('1')) 
        await dispatch(PostRequest(url.expenseDelete , userToken , {Srn:getId}))
        fetchData()
        dispatch(ShowLoader('0'))
    }
    // Table Data Ended
  return (
    <PageContainer title='Expenses' description='Expenses'>
        <form onSubmit={submitForm}>
        <Grid container>
            <Grid item lg={6}>
                    
                    <CustomForm key={formKey} data={data.inputs}  inputValues={inputValues} ChangeOnSelect={ChangeOnSelect}  handleInputChange={handleInputChange } />
                    <Box mt={2}>
                        <CustomBtn mt={2} data={data.btn.data}  style={data.btn.style} />
                    </Box>
            </Grid>
        </Grid>
                </form>


        <Box mt={3}>
                    <Grid container>
                        <Grid item lg={6}>
                        <CustomForm data={data.Date} ChangeOnSelect={ChangeOnSelectView} ChangeDate={ChangeDate}  />            
                        </Grid>

                    </Grid>
                    {
                        serverData && serverData.veiwDonation && serverData.veiwDonation.length !== 0 && (
                            <>
                                {/* <CustomForm data={serverData.veiwDonation} handleInputChange={handleInputChange} /> */}
                                <CustomTableFinance  data={serverData.veiwDonation} onDelete={deleteRecord} />
                            </>
                        )
                    }


        </Box>
    </PageContainer>
  )
}

Expense.propTypes = {}

export default Expense